import * as React from 'react';
import styled from 'styled-components';

import Checkbox from 'src/SharedComponents/Checkbox';

interface IProps {
    answers: string[],
    onAnswerChange: (questionId: number, answer: string, itemIndex?: number) => void,
    question: string,
    questionId: number,
    refProp?: React.RefObject<HTMLLIElement>,
    checkedItem?: number
};

const QuestionContainer = styled.li`
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    padding: 4px 12px;
    & > label > span {
        margin: 3px 6px;
    }
    &:nth-child(even) {
        background: #003087;
    }
`;

const Question = styled.p`
    flex: 1 1 auto;
`;

const UnlabeledMultipleChoiceQuestion = (props: IProps) => {
    const { answers, checkedItem, onAnswerChange, question, questionId, refProp } = props;

    const checkItem = (itemNumber: number) => (isChecked: boolean) => {
        if (isChecked) {
            onAnswerChange(questionId, answers[itemNumber], itemNumber);
        } else {
            onAnswerChange(questionId, "", -1);
        }
    };

    return <QuestionContainer ref={refProp}>
        <Question>{question}</Question>
        {answers.map((answer, index) => <label key={`question-${questionId}-answer-${index}`}>
                <Checkbox ariaLabel={answer} checked={checkedItem === index} onChange={checkItem(index)} />
            </label>
        )}
    </QuestionContainer>;
};

export default UnlabeledMultipleChoiceQuestion;



// WEBPACK FOOTER //
// ./src/SharedComponents/UnlabeledMultipleChoiceQuestion.tsx